import React from "react";
import "../styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import {
  faComments,
  faCalendarDays,
  faUserGroup,
  faHeart,
  faBookOpen,
  faFileInvoice,
  faTableList,
  faArrowRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import closeIcon from "./../images/close_icon.png";
import menuIcon from "./../images/menu_icon.png";
import placeholderAvatar from "./../images/placeholder-avatar.png";

const Dashboard = ({
  UserLandingData,
  setSelectedSection,
  setLogin,
  toggleSidebar,
  isSidebarOpen,
  isMobileWeb,
}) => {
  const username = localStorage.getItem("username");
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("userId");
    localStorage.removeItem("isAdmin");
    navigate("/");
    setLogin(false);
  };

  const switchScreen = (screen) => {
    setSelectedSection(screen);
    if (isMobileWeb) {
      toggleSidebar();
    }
  };

  return (
    <div className={`dashboardContainer ${isSidebarOpen ? "open" : "closed"}`}>
      <div className="dashboardCloseButton">
        <button className="dashboardCloseIcon" onClick={() => toggleSidebar()}>
          {isSidebarOpen ? (
            <img className="dashboardCloseIcon" src={closeIcon} alt="Button" />
          ) : (
            <img className="dashboardCloseIcon" src={menuIcon} alt="Button" />
          )}
        </button>
      </div>
      {isSidebarOpen ? (
        <div className="sticky-dashboard">
          <Link className="DBAvatarContainer">
            <img
              className="DBAvatarImage"
              src={placeholderAvatar}
              alt="Button"
            />
          </Link>
          <h3 className="textBlack">Hello {username}</h3>
          <h5 className="textBlack marginTop20">{username}</h5>
          {/* This is all of the buttons in the dashboard sidebar. */}
          <div className="dashboardButtonsContainer">
            <button
              className="dashboardButton"
              onClick={() => switchScreen("Messages")}
            >
              <FontAwesomeIcon className="dashboardIcon" icon={faComments} />
              <h5 className="textBlack">Messages</h5>
            </button>

            <button
              className="dashboardButton"
              onClick={() => switchScreen("Calendar")}
            >
              <FontAwesomeIcon
                className="dashboardIcon"
                icon={faCalendarDays}
              />
              <h5 className="textBlack">Calendar</h5>
            </button>

            <button
              className="dashboardButton"
              // onClick={() =>
              //   navigate("/Providers")}
              onClick={() => switchScreen("Provider")}
            >
              <FontAwesomeIcon className="dashboardIcon" icon={faUserGroup} />
              <h5 className="textBlack">Provider</h5>
            </button>

            <button
              className="dashboardButton"
              onClick={() => switchScreen("Services")}
            >
              <FontAwesomeIcon className="dashboardIcon" icon={faHeart} />
              <h5 className="textBlack">Services</h5>
            </button>

            <button
              className="dashboardButton"
              onClick={() => switchScreen("Booking")}
            >
              <FontAwesomeIcon className="dashboardIcon" icon={faBookOpen} />
              <h5 className="textBlack">Booking</h5>
            </button>

            <button
              className="dashboardButton"
              onClick={() => switchScreen("Patient")}
            >
              <FontAwesomeIcon className="dashboardIcon" icon={faFileInvoice} />
              <h5 className="textBlack">Self/Family</h5>
            </button>

            <button
              className="dashboardButton"
              onClick={() => switchScreen("Account")}
            >
              <FontAwesomeIcon className="dashboardIcon" icon={faTableList} />
              <h5 className="textBlack">Account</h5>
            </button>

            <button className="dashboardButton" onClick={handleLogout}>
              <FontAwesomeIcon
                className="dashboardIcon"
                icon={faArrowRightFromBracket}
              />
              <h5 className="textBlack">Logout</h5>
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Dashboard;
